
import { Link } from 'react-router-dom';
import CuotasDisponibles from './CuotasDisponibles';
import MisSolicitudes from './MisSolicitudes';

type Tab = 'cuotas' | 'solicitudes';

interface Props {
  activeTab: Tab;
}

export default function AdelantosPanel({ activeTab }: Props) {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
      <div className="border-b border-slate-200 dark:border-slate-800">
        <nav aria-label="Tabs" className="flex px-6">
          <Link
            to="/adelantos/cuotas"
            className={`border-b-2 py-4 px-6 text-sm font-semibold flex items-center gap-2 transition-colors ${
              activeTab === 'cuotas'
                ? 'border-primary text-primary'
                : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 font-medium'
            }`}
          >
            <span className="material-symbols-outlined text-lg">calendar_today</span>
            Cuotas Disponibles
          </Link>
          <Link
            to="/adelantos/solicitudes"
            className={`border-b-2 py-4 px-6 text-sm font-semibold flex items-center gap-2 transition-colors ${
              activeTab === 'solicitudes'
                ? 'border-primary text-primary'
                : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 font-medium'
            }`}
          >
            <span className="material-symbols-outlined text-lg">history</span>
            Mis Solicitudes
          </Link>
        </nav>
      </div>

      {activeTab === 'cuotas' ? <CuotasDisponibles /> : <MisSolicitudes />}
    </div>
  );
}
